// Fix for IE
if (!Array.from || !Array.prototype.find || !Array.prototype.findIndex) {
    require(__dirname + '/../js/polyfills/array.js');
}
if (!String.prototype.includes) {
    require(__dirname + '/../js/polyfills/string.js');
}

// Fix for Safari
if (!global.Intl) {
    require('intl');
    require('intl/locale-data/jsonp/en-GB.js');
}

import React from 'react';
import ReactDOM from 'react-dom';
import CentricMuiThemeProvider from './components/App/CentricMuiTheme';

import { browserHistory, Route, Router } from 'react-router';
import { IntlProvider } from 'react-intl';

import Layout from './components/App/Layout';
import LayoutGuest from './components/Pages/GuestLayout';
import LayoutShare from './components/Pages/ShareLayout';
import Home from './components/Pages/Home';
import Privacy from './components/Pages/Privacy';
import Terms from './components/Pages/Terms';
import Help from './components/Help/Help';
import NoMatch from './components/Pages/Error404';

import AccessGroupForm from './components/AccessGroup/AccessGroupForm.react';
import AccessGroupList from './components/AccessGroup/AccessGroupList';
import AddressForm from './components/Address/AddressForm.react';
import Asset from './components/Asset/Asset';
import AssetHistory from './components/Asset/Asset';
import AssetForm from './components/Asset/AssetForm.react';
import AssetEdit from './components/Asset/AssetEditPage';
import AssetHistoryList from './components/Asset/AssetHistoryList';
import AssetList from './components/Asset/AssetList';
import AssetSearch from './components/Asset/AssetSearch';
import Assignment from './components/Assignment/Assignment.react';
import AssignmentForm from './components/Assignment/AssignmentForm.react';
import AssignmentList from './components/Assignment/AssignmentList';
import AssignmentManage from './components/Assignment/AssignmentManage.react';
import AttributeList from './components/User/AttributeList';

import Library from './components/Library/Library';

import CategoryForm from './components/Category/CategoryForm.react';
import CategoryTree from './components/Category/CategoryTree';
import Calendar from './components/Calendar/Calendar';
import CalendarForm from './components/Calendar/CalendarForm';
import CalendarList from './components/Calendar/CalendarList';
import Certificate from './components/Certificate/Certificate';
import CertificateForm from './components/Certificate/CertificateForm';
import CertificateList from './components/Certificate/CertificateList';
import ComplianceEdit from './components/Compliance/ComplianceEdit';
import ComplianceList from './components/Compliance/ComplianceList';
import ComplianceProgress from './components/Compliance/ComplianceProgress';
import Contact from './components/Contact/Contact.react';
import ContactForm from './components/Contact/ContactForm.react';
import ContactList from './components/Contact/ContactList';
import Course from './components/Course/Course.react';
import CourseActivity from './components/Course/CourseActivity.react';
import CourseForm from './components/Course/CourseForm.react';
import CourseSettings from './components/Course/CourseSettings.react';
import CourseComplianceByUser from './components/Course/CourseComplianceByUser';
import CourseEnrolments from './components/Course/CourseEnrolments.react';
import CourseEnrolment from './components/Course/CourseEnrolment';
import CourseEnrolmentForm from './components/Course/CourseEnrolmentForm.react';
import CourseEnrolmentList from './components/Course/CourseEnrolmentList';
import CourseEnrolmentListByUser from './components/Course/CourseEnrolmentListByUser.react';
import CourseEnrolmentStats from './components/Course/CourseEnrolmentStats';
import CourseList from './components/Course/CourseList';

import Housekeeping from "./components/Housekeeping/Housekeeping";

import MyResourceList from './components/MyTraining/MyResourceList';
import MyTraining from './components/MyTraining/MyTraining';
import MyCourseList from './components/MyTraining/MyCourseList';
import MyModuleList from './components/MyTraining/MyModuleList';
import MySkillList from './components/MyTraining/MySkillList';
import MyClassList from './components/Module/MyClassList';
import MyActivities from './components/MyTraining/MyActivities';
import MyCompliance from './components/MyTraining/MyCompliance';

import Profile from './components/Profile/Profile';
import ProfileForm from './components/Profile/ProfileForm.react';

import Department from './components/Department/Department.react';
import DepartmentForm from './components/Department/DepartmentForm.react';

import EmailTemplate from './components/EmailTemplate/EmailTemplate';
import EmailTemplateForm from './components/EmailTemplate/EmailTemplateForm.react';
import EmailTemplateList from './components/EmailTemplate/EmailTemplateList';
import ErrorLog from './components/Log/ErrorLog';
import Event from './components/Event/Event';
import EventForm from './components/Event/EventForm.react';
import EventList from './components/Event/EventList';
import EventAssetForm from './components/Event/EventAssetForm.react';
import EventAttendees from './components/Event/EventAttendees';
import EventAttendeesPrintView from './components/Event/EventAttendeesPrintView';
import EventCalendar from './components/Event/EventCalendar';
import EventReminderForm from './components/Event/EventReminderForm.react';
import EventSettings from './components/Event/EventSettings.react';
import EventTrainers from './components/Event/EventTrainers';

import Filter from './components/Filter/Filter.react';
import FilterForm from './components/Filter/FilterForm.react';
import FilterList from './components/Filter/FilterList';

import Label from './components/Label/Label';
import LabelForm from './components/Label/LabelForm';
import LabelList from './components/Label/LabelList';
import Location from './components/Location/Location.react';
import LocationCalendar from './components/Location/LocationCalendar';
import LocationForm from './components/Location/LocationForm.react';
import LocationList from './components/Location/LocationList';

import MailLog from './components/Log/MailLog';
import Module from './components/Module/Module.react';
import ModuleActivity from './components/Module/ModuleActivity.react';
import ModuleCalendar from './components/Module/ModuleCalendar';
import ModuleForm from './components/Module/ModuleForm.react';
import ModuleImportForm from './components/Module/ModuleImportForm.react';
import ModuleEnrolment from './components/Module/ModuleEnrolment';
import ModuleEnrolments from './components/Module/ModuleEnrolments';
import ModuleEnrolmentsByUser from './components/Module/ModuleEnrolmentsByUser';
import ModuleEvents from './components/Module/ModuleEvents.react';
import ModuleEventAttendance from './components/Module/ModuleEventAttendance';
import ModuleEventForm from './components/Module/ModuleEventForm.react';
import ModuleList from './components/Module/ModuleList.react';
import ModuleSettings from './components/Module/ModuleSettings.react';

import NotificationList from './components/Notification/NotificationList';

import Organisation from './components/Organisation/Organisation.react';
import OrganisationForm from './components/Organisation/OrganisationForm.react';
import OrganisationList from './components/Organisation/OrganisationList';
import OrganisationSettings from './components/Organisation/OrganisationSettings';

import Programme from './components/Programme/Programme.react';
import ProgrammeForm from './components/Programme/ProgrammeForm';
import ProgrammeList from './components/Programme/ProgrammeList';

import Reminder from './components/Reminder/Reminder';
import Report from './components/Report/Report.react';
import ReportForm from './components/Report/ReportForm.react';
import ReportList from './components/Report/ReportList';
import ReportShare from './components/Report/ReportShare';
import ReportSchedule from './components/Report/ReportSchedule';
import ReportSchedules from './components/Report/ReportSchedules';
import ResourceSearch from './components/Module/ResourceSearch';
import ResourceContentSearch from './components/Module/ResourceContentSearch';

import SettingList from './components/Setting/SettingList.react';
import Skill from './components/Skill/Skill';
import SkillForm from './components/Skill/SkillForm.react';
import SkillList from './components/Skill/SkillList';
import Statement from './components/LearningRecordStore/Statement';
import StatementList from './components/LearningRecordStore/StatementList';
import SystemLog from './components/Log/SystemLog';
import SystemTasks from './components/SystemTasks/SystemTasks';
import SystemTaskJobs from './components/SystemTasks/SystemTaskJobs';

import TrainerEvents from './components/User/TrainerCalendar';
import TrainerList from './components/User/TrainerList';
import TrainerSchedule from './components/User/TrainerSchedule';

import User from './components/User/User';
import UserActivity from './components/User/UserActivity.react';
import UserCalendar from './components/User/UserCalendar';
import UserCompliance from './components/User/UserComplianceList';
import UserForm from './components/User/UserForm';
import UserImportForm from './components/User/UserImportForm.react';
import UserList from './components/User/UserList';
import UserSettings from './components/User/UserSettings.react';
import UserSkillList from './components/User/UserSkillList';
import UserGroup from './components/UserGroup/UserGroup.react';
import UserGroupForm from './components/UserGroup/UserGroupForm.react';
import UserGroupList from './components/UserGroup/UserGroupList';

import Vendor from './components/Vendor/Vendor';
import VendorForm from './components/Vendor/VendorForm.react';
import VendorList from './components/Vendor/VendorList';
import Venue from './components/Venue/Venue.react';
import VenueAssetForm from './components/Venue/VenueAssetForm.react';
import VenueEvents from './components/Venue/VenueCalendar';
import VenueForm from './components/Venue/VenueForm.react';
import VenueList from './components/Venue/VenueList';
import VenueSchedule from './components/Venue/VenueSchedule';
import VenueSettings from './components/Venue/VenueSettings.react';

import LogOut from './components/Auth/LogOut';
// Needed for onTouchTap
// Can go away when react 1.0 release
// Check this repo:
// https://github.com/zilverline/react-tap-event-plugin
import injectTapEventPlugin from 'react-tap-event-plugin';

// styles
require(__dirname + '/../css/fonts.css');
require(__dirname + '/../css/style.css');

injectTapEventPlugin();

ReactDOM.render(
    <IntlProvider locale="en-GB">
        <CentricMuiThemeProvider>
        <Router history={browserHistory}>
            <Route path="/dashboard" component={Layout}>
                <Route path="mytraining" component={MyTraining} />
                <Route path="mytraining/compliance" component={MyCompliance} />
                <Route path="mytraining/courses" component={({location}) => <MyCourseList completed={location.query.completed && location.query.completed === 'true'} />} />
                <Route path="mytraining/events" component={MyCourseList} />
                <Route path="mytraining/modules(/:type)" component={({params, location}) => <MyModuleList type={params.type} completed={location.query.completed && location.query.completed === 'true'} />}/>
                <Route path="mytraining/resources" component={MyResourceList} />
                <Route path="mytraining/skills" component={MySkillList} />
                <Route path="mytraining/activities" component={MyActivities} />
                <Route path="myteaching/modules" component={MyClassList} />
                <Route path="activity(/:verb)" component={({params}) => <StatementList verb={params.verb || 'completed'} />} />
                <Route path="accessgroups" component={AccessGroupList} />
                <Route path="accessgroup/new" component={AccessGroupForm} />
                <Route path="accessgroup/:id/edit" component={AccessGroupForm} />
                <Route path="address/new" component={AddressForm} />
                <Route path="address/:id/edit" component={AddressForm} />
                <Route path="assets(/:type)" component={AssetList} />
                <Route path="asset/new" component={AssetForm} />
                <Route path="assets/search" component={AssetSearch} />
                <Route path="asset/:id" component={Asset} />
                <Route path="asset/:id/edit" component={AssetEdit} />
                <Route path="asset/:id/history" component={AssetHistoryList} />
                <Route path="asset/:id/:version" component={AssetHistory} />
                <Route path="assignments" component={AssignmentList} />
                <Route path="assignment/new" component={AssignmentForm} />
                <Route path="assignment/:id" component={Assignment} />
                <Route path="assignment/:id/edit" component={AssignmentForm} />
                <Route path="assignment/:id/manage" component={AssignmentManage} />
                <Route path="attributes" component={AttributeList} />
                <Route path="category/new" component={CategoryForm} />
                <Route path="category/:categoryId/media/search" component={ResourceSearch} />
                <Route path="category/:id/edit" component={CategoryForm} />
                <Route path="category/:categoryId/module/:id" component={Module} />
                <Route path="calendar/new" component={CalendarForm} />
                <Route path="calendar/:id" component={Calendar} />
                <Route path="calendars" component={CalendarList} />
                <Route path="certificate/new" component={CertificateForm} />
                <Route path="certificate/:id" component={Certificate} />
                <Route path="certificate/:id/edit" component={CertificateForm} />
                <Route path="certificates" component={CertificateList} />
                <Route path="compliances" component={ComplianceList} />
                <Route path="compliance/new" component={ComplianceEdit} />
                <Route path="compliance/:id/edit" component={({params}) => <ComplianceEdit id={Number(params.id)}/>} />
                <Route path="compliance/:id/progress/:type" component={ComplianceProgress} />
                <Route path="contact/new" component={ContactForm} />
                <Route path="contact/:id" component={Contact} />
                <Route path="contact/:id/edit" component={ContactForm} />
                <Route path="contacts" component={ContactList} />
                <Route path="course/new" component={CourseForm} />
                <Route path="course/:id" component={Course} />
                <Route path="course/:courseId/module/:id" component={Module} />
                <Route path="course/:id/edit" component={CourseForm} />
                <Route path="course/:id/settings" component={CourseSettings} />
                <Route path="course/:id/activity" component={CourseActivity} />
                <Route path="course/:id/enrol" component={Course} />
                <Route path="course/:id/enrolments" component={CourseEnrolments} />
                <Route path="courses" component={CourseList} />
                <Route path="courses/enrolments" component={CourseEnrolmentList} />
                <Route path="courses/enrolments/user/:userId" component={CourseEnrolmentListByUser} />
                <Route path="courses/enrolments/stats/group/:groupBy" component={CourseEnrolmentStats} />
                <Route path="course/compliance/user/:id" component={CourseComplianceByUser} />
                <Route path="course/enrolment/:id" component={CourseEnrolment} />
                <Route path="course/enrolment/:id/edit" component={CourseEnrolmentForm} />
                <Route path="courses/stats" component={CourseList} />
                <Route path="department/new" component={DepartmentForm} />
                <Route path="department/:id" component={Department} />
                <Route path="department/:id/edit" component={DepartmentForm} />
                <Route path="event/new" component={EventForm} />
                <Route path="event/template/:templateId" component={EventForm}/>
                <Route path="event/:id" component={Event} />
                <Route path="event/:id/edit" component={EventForm} />
                <Route path="event/:id/settings" component={EventSettings} />
                <Route path="event/:id/attend" component={Event} />
                <Route path="event/:id/attendees" component={EventAttendees} />
                <Route path="event/:id/attendees/print" component={EventAttendeesPrintView} />
                <Route path="event/:id/trainers" component={EventTrainers} />
                <Route path="event/:eventId/asset/new" component={EventAssetForm} />
                <Route path="event/:eventId/reminder/new" component={EventReminderForm} />
                <Route path="event/:eventId/reminder/:reminderId" component={Reminder} />
                <Route path="event/:eventId/reminder/:reminderId/edit" component={EventReminderForm} />
                <Route path="events" component={EventList} />
                <Route path="events/calendar" component={EventCalendar}/>
                <Route path="email/templates" component={EmailTemplateList} />
                <Route path="email/template/new" component={EmailTemplateForm} />
                <Route path="email/template/:id" component={EmailTemplate} />
                <Route path="email/template/:id/edit" component={EmailTemplateForm} />
                <Route path="filters" component={FilterList} />
                <Route path="filter/new" component={FilterForm} />
                <Route path="filter/:id" component={Filter} />
                <Route path="filter/:id/edit" component={FilterForm} />
                <Route path="help" component={Help} />
                <Route path="housekeeping" component={Housekeeping} />
                <Route path="label/new" component={LabelForm} />
                <Route path="label/:id" component={Label} />
                <Route path="labels" component={LabelList} />
                <Route path="library/list" component={CategoryTree} />
                <Route path="library(/:id)(/:type)" component={Library} />
                <Route path="location/new" component={LocationForm} />
                <Route path="location/:id" component={Location} />
                <Route path="location/:id/edit" component={LocationForm} />
                <Route path="location/:id/calendar" component={LocationCalendar} />
                <Route path="locations" component={LocationList} />
                <Route path="logs/error" component={ErrorLog} />
                <Route path="logs/mail" component={MailLog} />
                <Route path="logs/system" component={SystemLog} />
                <Route path="modules" component={ModuleList} />
                <Route path="modules/resource/search" component={ResourceSearch} />
                <Route path="modules/resource/search/content" component={ResourceContentSearch} />
                <Route path="modules/enrolments/user/:id" component={ModuleEnrolmentsByUser} />
                <Route path="modules/:type" component={({params}) => <ModuleList type={params.type} />}/>
                <Route path="module/new" component={ModuleForm} />
                <Route path="module/new/type/:typeId" component={ModuleForm} />
                <Route path="module/new/fromAsset/:assetId" component={ModuleForm} />
                <Route path="module/import" component={ModuleImportForm} />
                <Route path="module/:id" component={Module} />
                <Route path="module/:id/activity" component={ModuleActivity} />
                <Route path="module/:id/calendar" component={ModuleCalendar} />
                <Route path="module/:moduleId/user/:userId/enrolment" component={({params}) => <ModuleEnrolment moduleId={Number(params.moduleId)} userId={Number(params.userId)} />}/>
                <Route path="module/:id/enrolments" component={ModuleEnrolments} />
                <Route path="module/:id/edit" component={ModuleForm} />
                <Route path="module/:id/events" component={ModuleEvents} />
                <Route path="module/:id/event/new" component={ModuleEventForm} />
                <Route path="module/:moduleId/event/:id" component={Event} />
                <Route path="module/:id/event/:eventId/edit" component={ModuleEventForm} />
                <Route path="module/:id/event/:eventId/attendance" component={ModuleEventAttendance} />
                <Route path="module/:id/settings" component={ModuleSettings} />
                <Route path="notifications" component={NotificationList} />
                <Route path="organisation/new" component={OrganisationForm} />
                <Route path="organisation/:id" component={Organisation} />
                <Route path="organisation/:id/edit" component={OrganisationForm} />
                <Route path="organisations" component={OrganisationList} />
                <Route path="organisation/:id/settings" component={OrganisationSettings}/>
                <Route path="profile" name="profile" component={Profile} />
                <Route path="profile/edit" name="profileEdit" component={ProfileForm} />
                <Route path="profile/:id" name="profile" component={Profile} />
                <Route path="programmes" component={ProgrammeList} />
                <Route path="programme/new" component={ProgrammeForm} />
                <Route path="programme/:id" component={Programme} />
                <Route path="programme/:id/edit" component={ProgrammeForm} />
                <Route path="settings" component={SettingList} />
                <Route path="skill/new" component={SkillForm} />
                <Route path="skill/:id(/user/:userId)" component={Skill} />
                <Route path="skill/:id/edit" component={SkillForm} />
                <Route path="skills" component={SkillList} />
                <Route path="reports" component={ReportList} />
                <Route path="reports/schedules" component={ReportSchedules} />
                <Route path="reports/schedule/:id" component={ReportSchedule} />
                <Route path="report/new" component={ReportForm} />
                <Route path="report/:id" component={Report} />
                <Route path="report/:id/edit" component={ReportForm} />
                <Route path="system/tasks" component={SystemTasks} />
                <Route path="system/task/:taskId/jobs" component={SystemTaskJobs} />
                <Route path="trainers" component={TrainerList} />
                <Route path="trainers/events" component={TrainerEvents} />
                <Route path="trainers/schedule" component={TrainerSchedule} />
                <Route path="user/new" component={UserForm}/>
                <Route path="user/:id" component={User}/>
                <Route path="user/:id/edit" component={UserForm}/>
                <Route path="user/:id/settings" component={UserSettings}/>
                <Route path="user/:id/skills" component={({params}) => <UserSkillList userId={Number(params.id)} />}/>
                <Route path="user/:id/activity" component={UserActivity}/>
                <Route path="user/:id/calendar" component={UserCalendar}/>
                <Route path="user/:id/compliance" component={({params}) => <UserCompliance userId={Number(params.id)} />} />
                <Route path="users" component={UserList} />
                <Route path="users/import" component={UserImportForm} />
                <Route path="usergroup/new" component={UserGroupForm} />
                <Route path="usergroup/:id" component={UserGroup} />
                <Route path="usergroup/:id/edit" component={UserGroupForm} />
                <Route path="usergroups" component={UserGroupList} />
                <Route path="vendor/new" component={VendorForm} />
                <Route path="vendor/:id" component={Vendor} />
                <Route path="vendor/:id/edit" component={VendorForm} />
                <Route path="vendors" component={VendorList} />
                <Route path="venue/new" component={VenueForm} />
                <Route path="venue/:id" component={Venue} />
                <Route path="venue/:id/edit" component={VenueForm} />
                <Route path="venue/:id/settings" component={VenueSettings} />
                <Route path="venue/:id/asset/new" component={VenueAssetForm} />
                <Route path="venue/:id/events" component={VenueEvents} />
                <Route path="venue/:id/schedule" component={VenueSchedule} />
                <Route path="venue/:venueId/location" component={LocationForm} />
                <Route path="venues" component={VenueList} />

                <Route path="statement/:id" component={Statement} />
                <Route path="admin" component={Layout}>
                    <Route path="users" component={UserList} />
                </Route>
            </Route>

            <Route path="/" component={LayoutGuest}>
                <Route path="home" component={Home}/>
                <Route path="logout" component={LogOut}/>
                <Route path="policy/terms" component={Terms}/>
                <Route path="policy/privacy" component={Privacy}/>
            </Route>

            <Route path="/shared" component={LayoutShare}>
                <Route path="reporting/:key" component={ReportShare}/>
            </Route>

            <Route path="*" component={NoMatch} />
        </Router>
        </CentricMuiThemeProvider>
    </IntlProvider>,
    document.getElementById('app')
);
